export * from './component/home/home.component';
export * from './component/login/login.component';

export * from './home.routing';
